import cn from 'clsx';

export const Checkbox = ({
  className,
  label,
  prefix,
  register,
  name,
  validations,
  ...inputprops
}) => {
  return (
    <label className='flex items-center justify-start gap-4 dark:bg-white'>
      <input
        type='checkbox'
        className={cn(
          'peer px-2 py-1 md:px-4 md:py-2 bg-white dark:bg-white',
          'border border-neutral-600 ',
          'outline-neutral-800 outline-offset-0',
          'text-sm md:text-base',
          {'pl-8': prefix},
          className
        )}
        {...inputprops}
        {...register(name, validations)}
      />
      <span>{label}</span>
    </label>
  );
};
